let promise = null;

export const loadYandexApi = (apiKey) => {
    if (promise) return promise; // Если уже грузим или загрузили — возвращаем текущий promise

    promise = new Promise((resolve, reject) => {
        if (typeof ymaps !== 'undefined') {
            resolve(window.ymaps);
            return;
        }

        const script = document.createElement('script');
        script.src = `https://api-maps.yandex.ru/2.1/?apikey=${apiKey}&lang=ru_RU`;
        script.async = true;
        script.onload = () => {
            window.ymaps.ready(() => resolve(window.ymaps));
        };
        script.onerror = (err) => reject(err);
        document.head.appendChild(script);
    });

    return promise;
};
